<template>
  <div>
    <Forms ref="frmSinisterRegulation"
      :title="$lang.Sinister.Regulation.TitleForm"
      :showHelp="true"
      :showClearButton="false"
      :showSearchButton="false">
      <Alerts ref="alert"/>
      <SinisterHeader ref="SinisterHeader"/>

      <div class="form-group row"><div class="col-md-12"><hr></div></div>
        <div>
          <div class="form-group row">
            <div class="col-md-2">
              <label for="txtActionDateRegulation"><small v-show="form.actionDate.required"  class="text-danger">*</small> {{$lang.Sinister.Regulation.ActionDate}}:</label>
              <div class="input-group">
                <datepicker name="txtActionDateRegulation" v-model="form.actionDate.value"
                            :format="'dd/MM/yyyy'"
                            :language="ptBR"
                            :placeholder="$lang.Common.DatePlaceholder"
                            :clear-button="false"
                            :clear-button-icon="'fa fa-close'"
                            :calendar-button="false"
                            :calendar-button-icon="'fa fa-calendar'"
                            :bootstrap-styling="true"
                            :full-month-name="true"
                            :use-utc="true"
                            :disabled="disableActionDateRegulation"/>
              </div>
            </div>
            <div class="col-md-2">
              <label for="cbxTypeConclusion">Tipo de Conclusão</label>
              <div class="input-group">
                <b-form-select v-model="form.typeConclusion.value"
                              :options="form.typeConclusion.options"
                              :state="form.typeConclusion.state"
                              class="mb-3"
                              name="cbxTypeConclusion"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Autorizado</option>
                  <option :value="2">Não autorizado</option>
                  <option :value="3">Frustrada</option>
                  <option :value="5">Não acordo</option>
                  <option :value="4" disabled>Outros</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-2" v-show="form.typeConclusion.value == 3">
              <label for="cbxReasonFrustration">Motivo da Frustração</label>
              <div class="input-group">
                <b-form-select v-model="form.reasonFrustration.value"
                              :options="form.reasonFrustration.options"
                              :state="form.reasonFrustration.state"
                              class="mb-3"
                              name="cbxReasonFrustration"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Pedido Indevido</option>
                  <option :value="2">Veículo Ausente</option>
                  <option :value="3">Orçamento em elaboração</option>
                  <option :value="5">Responsável Ausente</option>
                  <option :value="4" disabled>Realizado pela CIA</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-2" v-show="canReprogram">
              <label for="cbxReprogramSurvey">Deseja reprogramar a vistoria ?</label>
              <div class="input-group">
                <b-form-select v-model="form.reprogramSurvey.value"
                              :options="form.reprogramSurvey.options"
                              :state="form.reprogramSurvey.state"
                              class="mb-3"
                              name="cbxReprogramSurvey"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Sim</option>
                  <option :value="2">Não</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6" v-show="form.typeConclusion.value == 4">
            <label for="txtSpecify"> Especifique</label>
            <b-form-textarea name="txtSpecify"
                            v-model="form.description.value"
                            :placeholder="$lang.Sinister.Details.PlaceholderSeem"
                            :rows="form.description.rows"
                            :size="form.description.maxlength"
                            :noResize="form.description.noResize"
                            :disabled="isCompleted"/>
            </div>
            <div class="col-md-2" v-show="form.typeConclusion.value != 3">
              <label for="cbxLossType">Tipo de Perda</label>
              <div class="input-group">
                <b-form-select v-model="form.lossType.value"
                              :options="form.lossType.options"
                              :state="form.lossType.state"
                              class="mb-3"
                              name="cbxLossType"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Perda Parcial</option>
                  <option :value="2">Indenização Integral</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3" v-show="form.lossType.value == 1">
              <label for="cbxBudget">Orçamento está entre 60% a 74% da FIPE?</label>
              <div class="input-group">
                <b-form-select v-model="form.budget.value"
                              :options="form.budget.options"
                              :state="form.budget.state"
                              class="mb-3"
                              name="cbxBudget"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3" v-show="form.lossType.value == 2">
              <label for="cbxEngineNumber">Tem foto do Número do Motor?</label>
              <div class="input-group">
                <b-form-select v-model="form.engineNumber.value"
                              :options="form.engineNumber.options"
                              :state="form.engineNumber.state"
                              class="mb-3"
                              name="cbxEngineNumber"
                              :disabled="isCompleted">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                  <option :value="1">Sim</option>
                  <option :value="0">Não</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>

      <div class="form-group row pb-3" v-if="hasRole(this.roles.RW_REG_TABREGULATION)" v-show="!isCompleted">
        <div class="col-md-12 text-left force-border-bottom pl-3">
          <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" :disabled="isCompleted"><i class="fa fa-check-circle"></i> {{$lang.Common.Buttons.Save}} </button>&nbsp;
          <button type="button" class="btn btn-default btn-sm text-secundary" v-on:click="onClear" :disabled="isCompleted"><i class="fa fa-minus-circle"></i> {{$lang.Common.Buttons.Clear}} </button>&nbsp;
        </div>
      </div>

    </Forms>
  </div>
</template>
<script>
import SinisterRegulation from './sinisterregulation.js'

export default SinisterRegulation
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/auto/regulation/sinisterregulation.vue